import { useLingui } from '@lingui/react/macro';

import { useSummaryBackgroundContent } from '@/modules/claims/freeClaims/insuranceExport/constants';
import { useImageFallback } from '@/utils/hooks';

const HEADING_CLASSES = 'vai-m-0 vai-font-bold vai-text-lg vai-mb-2';
const BODY_CLASSES = `vai-font-['proxima-nova'] vai-text-sm vai-m-0 vai-leading-none`;

type ClaimFooterProps = {
  showClinicalValuesExplanation: boolean;
  showDmfExplanation: boolean;
  showRblExplanation: boolean;
  showRestoExplanation: boolean;
};

export const ClaimFooter = ({
  showClinicalValuesExplanation,
  showDmfExplanation,
  showRblExplanation,
  showRestoExplanation,
}: ClaimFooterProps) => {
  const { dmf, resto, rbl, display } = useSummaryBackgroundContent();

  const {
    i18n: { locale },
  } = useLingui();

  const { imgSrc: rblImgSrc, onError: rblOnError } = useImageFallback(
    `/assets/images/rblMeasurementGuide/insdiagram-${locale}.png`,
    '/assets/images/rblMeasurementGuide/insdiagram-en.png',
  );

  return (
    <div
      
      data-testid="claim-footer"
      className="vai-w-full vai-flex vai-flex-col vai-gap-8"
    >
      {showDmfExplanation && (
        <section>
          <h2 className={HEADING_CLASSES}>* {dmf.title}</h2>
          <p className={BODY_CLASSES}>{dmf.body}</p>
        </section>
      )}
      {showRestoExplanation && (
        <section>
          <h2 className={HEADING_CLASSES}>** {resto.title}</h2>
          <p className={BODY_CLASSES}>{resto.body}</p>
        </section>
      )}
      {showRblExplanation && (
        <section>
          <h2 className={HEADING_CLASSES}>{rbl.title}</h2>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <img
            src={rblImgSrc}
            alt="RBL"
            className="rbl-diagram"
            onError={rblOnError}
          />
          <p className={BODY_CLASSES}>{rbl.body}</p>
        </section>
      )}
      {showClinicalValuesExplanation && (
        <section>
          <h2 className={HEADING_CLASSES}>{display.title}</h2>
          <p className={BODY_CLASSES}>{display.body}</p>
        </section>
      )}
    </div>
  );
};
